/**
 * Trial metadata helpers for checkout UI (estimate response or session checkoutProcessDto).
 */

export function normalizeSessionTrial(trial) {
  if (!trial) return null;
  const inTrial = trial.inTrial === true || trial.inTrial === "true";
  if (!inTrial) return null;
  const amountDueNow =
    trial.amountDueNow != null ? Number(trial.amountDueNow) : 0;
  return {
    ...trial,
    inTrial: true,
    amountDueNow: Number.isNaN(amountDueNow) ? 0 : amountDueNow,
  };
}

export function resolveTrialMetadata(source) {
  if (!source) return null;
  const trial = source.trial || source.billingData?.trialMetadata;
  const normalized = normalizeSessionTrial(trial);
  if (!normalized) return null;
  return normalized;
}

export function isZeroAmountTrial(trial, amountDue) {
  if (!trial?.inTrial) return false;
  const due =
    amountDue ??
    trial.amountDueNow ??
    (typeof trial.amountDueNow === "string" ? Number(trial.amountDueNow) : null);
  if (due == null || Number.isNaN(Number(due))) return true;
  return Number(due) === 0;
}

export function formatTrialEndDate(trialEnd, locale = "en") {
  if (!trialEnd) return null;
  const date = new Date(trialEnd);
  if (Number.isNaN(date.getTime())) return null;
  try {
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  } catch {
    return date.toLocaleDateString();
  }
}

/** V1 trial-capable gateway × payment method pairs (must match backend registry). */
const TRIAL_SUPPORTED_PAIRS = new Set([
  "pagbrasil_card",
  "pagbrasil_pix",
  "adyen_card",
  "nuvei_card",
  "checkoutcom_card",
  "checkoutcom_applepay",
  "checkoutcom_kakaopay",
  "dlocal_card",
  "dlocal_pix",
  "dlocal_upi",
  "trustly_openbanking",
]);

export function isTrialSupportedPaymentOption(method, platform) {
  if (!method || !platform) return false;
  const key = `${String(platform).toLowerCase()}_${String(method).toLowerCase()}`;
  return TRIAL_SUPPORTED_PAIRS.has(key);
}

export function filterRoutingEntriesForTrial(routingEntries, trial) {
  if (!trial?.inTrial || !Array.isArray(routingEntries)) {
    return routingEntries || [];
  }
  return routingEntries.filter(
    (entry) =>
      entry?.paymentMethod &&
      entry?.platform &&
      isTrialSupportedPaymentOption(entry.paymentMethod, entry.platform)
  );
}
